import { render, staticRenderFns } from "./bugs_exposed_histogram.vue?vue&type=template&id=d0d55796&"
import script from "./bugs_exposed_histogram.vue?vue&type=script&lang=ts&"
export * from "./bugs_exposed_histogram.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports